import { injectable } from 'inversify';

import { Filter } from '@vk-hr-tek/core/filter';

import { UnitItem } from '@app/gen/vacations';

@injectable()
export class AbsencesListMapper {
  /* eslint-disable no-magic-numbers */
  processListFilters(filters: Filter[]) {
    if (!filters) return null;

    return filters.map((filter) => {
      if (filter.type === 'multiple-search' && filter.key === 'employee_ids') {
        return {
          ...filter,
          twoLine: true,
          minInputValueLength: 3,
          fullWidth: false,
        };
      }

      if (filter.type === 'search' && filter.key === 'parent_event_id') {
        return {
          ...filter,
          width: 12 as const,
          disabled: true,
        };
      }

      if (filter.type === 'bool') {
        return {
          ...filter,
          width: 12 as const,
          fullWidth: false,
          labelPlacement: 'end' as const,
        };
      }

      if (filter.type === 'multiple-search' && filter.key === 'unit_ids') {
        return {
          ...filter,
          fullWidth: true,
          width: 12 as const,
        };
      }

      if (filter.type === 'select' && filter.key === 'event_batch') {
        return {
          ...filter,
          autocomplete: true,
        };
      }

      if (filter.type === 'select' && filter.key === 'event_type_group') {
        return {
          ...filter,
          options: [...filter.options].sort((a, b) =>
            (a.label || '').toLowerCase() > (b.label || '').toLowerCase()
              ? 1
              : -1,
          ),
          autocomplete: true,
        };
      }

      return {
        ...filter,
        fullWidth: false,
      };
    });
  }

  processUnitsList(units?: UnitItem[]) {
    if (units && Array.isArray(units)) {
      const reversedUnits = [...units].reverse();

      return reversedUnits;
    }

    return [];
  }

  findFormRoleFields(
    formValuesObj: Record<string, string>,
    getFullFieldName?: boolean,
  ) {
    return Object.keys(formValuesObj)
      .map((key) => {
        const regexpResultArray = key.match(/^roles_([0-9a-zA-Z-]+)$/);

        if (regexpResultArray) {
          return getFullFieldName ? regexpResultArray[0] : regexpResultArray[1];
        }

        return null;
      })
      .filter((roleId) => roleId);
  }

  gatherAssignedRolesForBatch(formValuesObj: Record<string, string>) {
    return this.findFormRoleFields(formValuesObj).reduce(
      (acc: string[], roleId) => {
        return !roleId
          ? acc
          : [...acc, `${roleId}:${formValuesObj[`roles_${roleId}`]}`];
      },
      [],
    );
  }
}
